// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1liJT","newExpiryDate":"styles_newExpiryDate__1_0ht","footer":"styles_footer__1z7JD"};